import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR_MENU } from "../../utils/uiText";

const GET_MENU = "GET_MENU";
const GET_MENU_CLEAN = "GET_MENU_CLEAN";
const GET_MENU_ERROR = "GET_MENU_ERROR";
const GET_MENU_ERROR_SERVICE = "GET_MENU_ERROR_SERVICE";
const LOADING_MENU = "LOADING_MENU";

const initialState = {
  menu: [],
  messageError: "",
  loading: false,
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU:
      return {
        ...state,
        menu: action.payload,
        messageError: null,
      };
    case GET_MENU_ERROR:
      return {
        ...state,
        messageError: ERROR_MENU,
        menu: [],
        loading: false,
      };
    case GET_MENU_ERROR_SERVICE:
      return {
        ...state,
        menu: [],
        loading: false,
        messageError: ERROR_MENU,
      };
    case GET_MENU_CLEAN:
      return initialState;
    case LOADING_MENU:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default menuReducer;

const setLoading = (status) => ({
  type: LOADING_MENU,
  payload: status,
});

export const getMenu = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));

    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlGestorModulos}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + getState().usuarioLogin.accessToken,
        },
      }
    );
    dispatch({
      type: GET_MENU,
      payload: response.data,
    });
    dispatch(setLoading(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_MENU_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_MENU_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const cleanMenu = () => (dispatch) => {
  dispatch({
    type: GET_MENU_CLEAN,
  });
};
